import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "96",
  height: "96",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<rect width=\"96\" height=\"96\" fill=\"#DEFAEA\" rx=\"48\"></rect><circle cx=\"48\" cy=\"48\" r=\"28\" fill=\"#53D58B\"></circle><path stroke=\"#000\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M55 57v-6m0 0-3 3m3-3 3 3m-10-3h-4c-1.864 0-2.796 0-3.53.304a4 4 0 0 0-2.166 2.165C38 54.204 38 55.136 38 57m13.5-17.71a4.001 4.001 0 0 1 0 7.42m-2-3.71a4 4 0 1 1-8 0 4 4 0 0 1 8 0\"></path><circle cx=\"70\" cy=\"70\" r=\"12\" fill=\"#000\"></circle><path stroke=\"#53D58B\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M76 69.451v.552a6 6 0 1 1-3.558-5.483\"></path><path stroke=\"#53D58B\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"m76 65.204-6 6.006-1.8-1.8\"></path>", 6)
const _hoisted_8 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_8]))
}
export default { render: render }